/**
 * Upgrade variants surfaced by the product-page pricing chart.
 *
 * Mirrors what each family's /store/ page already offers: Samplitude's "Upgrade" tab sells the
 * Magix-serial `Upgrade` product, while Music Studio's four-card grid sells the `U&S Renewal`
 * under an "Upgrade + Support" label. Families absent from this map keep the chart's original
 * subscription/perpetual options only.
 */
export type UpgradeOption = {
    /** Backend WebProduct.type to look up in the family's product list. */
    productType: string
    /** Key under `productTypes` in the pricing-tool locale namespace. */
    labelKey: string
}

const UPGRADE_OPTIONS: Record<string, UpgradeOption> = {
    'samplitude': { productType: 'Upgrade', labelKey: 'upgrade' },
    'samplitude suite': { productType: 'Upgrade', labelKey: 'upgrade' },
    'music studio': { productType: 'U&S Renewal', labelKey: 'upgradeAndSupport' },
}

export const getUpgradeOption = (familyName: string): UpgradeOption | null => {
    if (!familyName) {
        return null;
    }
    return UPGRADE_OPTIONS[familyName.toLowerCase()] || null;
}
